import { gql } from '@apollo/client';

export const COPY_INVIATION_TEMPLATE = gql`
  mutation createPublisherInvitation($input: PublisherInvitationInput!) {
    createPublisherInvitation(input: $input) {
      id
      merchantId
      name
      description
      subject
      message
      template
    }
  }
`;
